// extracted by mini-css-extract-plugin
module.exports = {"contractDetailInformationRoot":"contractDetailInformationRoot--8239b"};